import UseSvg from "common/vue/components/UseSvg.react.vue";

export default function PinningZoom({ zoom, maxZoom = 10, isDesktop = false, onUpdateZoom }) {
  const ZOOM_STEP = 0.25;
  const MIN_ZOOM = 1;

  function zoomPercentage() {
    return Math.round(zoom * 100);
  }

  function canZoomIn() {
    return zoom < maxZoom;
  }

  function canZoomOut() {
    return zoom > MIN_ZOOM;
  }

  function handleZoomIn() {
    const newZoom = Math.min(zoom + ZOOM_STEP, maxZoom);
    onUpdateZoom(newZoom);
  }

  function handleZoomOut() {
    const newZoom = Math.max(zoom - ZOOM_STEP, MIN_ZOOM);
    onUpdateZoom(newZoom);
  }

  return (
    <>
      {}
      {!isDesktop ? (
        <div
          className="flex h-10 items-center rounded-lg bg-white shadow-md"
          data-testid="pinning-zoom-controls"
        >
          <button
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-l-lg border-none bg-transparent p-1.5 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            type="button"
            disabled={!canZoomOut()}
            data-testid="pinning-zoom-out-button"
            onClick={handleZoomOut}
          >
            <UseSvg className="h-5 w-5" icon="zoom-out-o" data-testid="h-5" />
          </button>
          <div className="h-8 w-px bg-gray-100" />
          <button
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-r-lg border-none bg-transparent p-1.5 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            type="button"
            disabled={!canZoomIn()}
            data-testid="pinning-zoom-in-button"
            onClick={handleZoomIn}
          >
            <UseSvg className="h-5 w-5" icon="zoom-in-o" data-testid="h-5-1" />
          </button>
        </div>
      ) : (
        <div
          className="flex h-10 items-center gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-sm"
          data-testid="pinning-zoom-controls"
        >
          <button
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border-none bg-transparent hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            type="button"
            disabled={!canZoomOut()}
            aria-label="Zoom out"
            data-testid="pinning-zoom-out-button"
            onClick={handleZoomOut}
          >
            <UseSvg className="h-4 w-4" icon="minus" data-testid="h-4" />
          </button>
          <div
            className="flex h-8 w-14 select-none items-center justify-center rounded-md border border-gray-200 bg-white text-sm font-medium text-gray-700"
            role="status"
            aria-label="Zoom percentage"
            data-testid="flex"
          >
            {zoomPercentage()}%{" "}
          </div>
          <button
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border-none bg-transparent hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            type="button"
            disabled={!canZoomIn()}
            aria-label="Zoom in"
            data-testid="pinning-zoom-in-button"
            onClick={handleZoomIn}
          >
            <UseSvg className="h-4 w-4" icon="plus" data-testid="h-4-1" />
          </button>
        </div>
      )}
    </>
  );
}

PinningZoom.displayName = "PinningZoom";
